__turbopack_context__.v({
  "bg": "PressureCard-module__v5nmwa__bg",
  "bgImage": "PressureCard-module__v5nmwa__bgImage",
  "chromeIcon": "PressureCard-module__v5nmwa__chromeIcon",
  "count": "PressureCard-module__v5nmwa__count",
  "countBlock": "PressureCard-module__v5nmwa__countBlock",
  "countLabel": "PressureCard-module__v5nmwa__countLabel",
  "face": "PressureCard-module__v5nmwa__face",
  "icon": "PressureCard-module__v5nmwa__icon",
  "label": "PressureCard-module__v5nmwa__label",
  "name": "PressureCard-module__v5nmwa__name",
  "reveal": "PressureCard-module__v5nmwa__reveal",
  "revealBody": "PressureCard-module__v5nmwa__revealBody",
  "revealBodyViewport": "PressureCard-module__v5nmwa__revealBodyViewport",
  "revealCta": "PressureCard-module__v5nmwa__revealCta",
  "revealScrollCue": "PressureCard-module__v5nmwa__revealScrollCue",
  "revealScrollRegion": "PressureCard-module__v5nmwa__revealScrollRegion",
  "root": "PressureCard-module__v5nmwa__root",
  "scrim": "PressureCard-module__v5nmwa__scrim",
});
